import React from "react";
import { Box } from "@material-ui/core";
import progressStepsStyle from "../../styles/progressStepsStyle";

const ProgressSteps = ({
  totalSteps,
  currentStep,
}: {
  totalSteps: number;
  currentStep: number;
}) => {
  const style = progressStepsStyle();

  return (
    <Box className={style.progressContainer}>
      {Array.from({ length: totalSteps }, (_, index) => (
        <React.Fragment key={index}>
          <Box
            className={`${style.progressStep} ${
              index === currentStep ? style.activeStep : ""
            }`}
          />
          {index < totalSteps - 1 && <Box className={style.progressLine} />}
        </React.Fragment>
      ))}
    </Box>
  );
};

export default ProgressSteps;
